<script>
  import Selector from '../../lib/components/Selector.svelte';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import session from '../../lib/session.js';
  import { onMount } from 'svelte';
  import { MDCDialog } from '@material/dialog';

  export let form_input;
  export let dialog_edit_lang;
  export let add_new_language;
  export let close_dialog_language;
  export let selectors;

  let labels = {
    language: null,
    proficiency: null,
    no_language_added: null,
    no_education_added: null,
    add_language: null,
    add_education: null,
    type: null,
    title: null,
    where: null,
    completed: null,
    in_progress: null,
    btn_back: null,
    btn_next: null,
    btn_close: null,
    btn_add: null,
    btn_cancel: null,
    btn_yes: null,
    btn_save: null,
    completed_month: null,
    completed_year: null,
    current: null,
    edit_lang: null,
    edit_edu: null,
    tooltip: {
      language: null,
      education: null,
    },
    dialog: {
      delete_lang: {
        title: null,
        content: null,
      },
      delete_edu: {
        title: null,
        content: null,
      },
    },
    languages: {
      ar: null,
      en: null,
      fa: null,
      fi: null,
      ru: null,
      sv: null,
    },
  };

  let dialog;

  const init_dialog = () => {
    dialog = new MDCDialog(document.getElementById(`dialog-language`));
  };

  export const open = () => {
    dialog.open();
  };

  export const close = () => {
    dialog.close();
  };

  const translate_texts = () => {
    labels.language = t9n(TS.REGISTER_LABEL_LANGUAGE);
    labels.proficiency = t9n(TS.SETTINGS_LABEL_PROFICIENCY);
    labels.no_language_added = t9n(TS.SETTINGS_LABEL_NO_LANG_ADDED);
    labels.no_education_added = t9n(TS.SETTINGS_LABEL_NO_EDU_ADDED);
    labels.add_language = t9n(TS.SETTINGS_LABEL_ADD_LANG);
    labels.add_education = t9n(TS.SETTINGS_LABEL_ADD_EDU);
    labels.type = t9n(TS.SETTINGS_LABEL_TYPE);
    labels.title = t9n(TS.SETTINGS_LABEL_TITLE);
    labels.where = t9n(TS.SETTINGS_LABEL_WHERE);
    labels.completed = t9n(TS.ORDER_COMPLETED_TXT);
    labels.in_progress = t9n(TS.TABLE_CHIP_IN_PROG);
    labels.btn_back = t9n(TS.TXT_BACK);
    labels.btn_next = t9n(TS.TABLE_BUTTON_NEXT);
    labels.btn_close = t9n(TS.LOGIN_FORM_CLOSE);
    labels.btn_add = t9n(TS.ORDERER_TEAMS_ADD_LABEL);
    labels.btn_cancel = t9n(TS.ORDERER_TEAMS_CANCEL_LABEL);
    labels.btn_yes = t9n(TS.TXT_YES);
    labels.completed_month = t9n(TS.SETTINGS_LABEL_COMPLETED_MONTH);
    labels.completed_year = t9n(TS.SETTINGS_LABEL_COMPLETED_YEAR);
    labels.current = t9n(TS.SETTINGS_LABEL_CURRENT);
    labels.btn_save = t9n(TS.CHANGE_PASSWORD_SUBMIT_LABEL);
    labels.edit_lang = t9n(TS.SETTINGS_LABEL_EDIT_LANG);
    labels.edit_edu = t9n(TS.SETTINGS_LABEL_EDIT_EDU);
    labels.dialog.delete_lang.title = t9n(TS.SETTINGS_LABEL_DELETE);
    labels.dialog.delete_lang.content = t9n(TS.TXT_ARE_YOU_SURE);
    labels.dialog.delete_edu.title = t9n(TS.MENU_LABEL_PERSONALINFO);
    labels.dialog.delete_edu.content = t9n(TS.SETTINGS_LABEL_DELETE);
    labels.languages.ar = t9n(TS.SETTINGS_LABEL_LANG_AR);
    labels.languages.en = t9n(TS.SETTINGS_LABEL_LANG_EN);
    labels.languages.fa = t9n(TS.SETTINGS_LABEL_LANG_FA);
    labels.languages.fi = t9n(TS.SETTINGS_LABEL_LANG_FI);
    labels.languages.ru = t9n(TS.SETTINGS_LABEL_LANG_RU);
    labels.languages.sv = t9n(TS.SETTINGS_LABEL_LANG_SV);
    labels.tooltip.language = t9n(TS.SETTINGS_LABEL_TOOLTIP_LANG);
    labels.tooltip.education = t9n(TS.SETTINGS_LABEL_TOOLTIP_EDU);

    selectors.education.months[0].name = t9n(TS.SETTINGS_LABEL_MONTH_JAN);
    selectors.education.months[1].name = t9n(TS.SETTINGS_LABEL_MONTH_FEB);
    selectors.education.months[2].name = t9n(TS.SETTINGS_LABEL_MONTH_MAR);
    selectors.education.months[3].name = t9n(TS.SETTINGS_LABEL_MONTH_APR);
    selectors.education.months[4].name = t9n(TS.SETTINGS_LABEL_MONTH_MAY);
    selectors.education.months[5].name = t9n(TS.SETTINGS_LABEL_MONTH_JUN);
    selectors.education.months[6].name = t9n(TS.SETTINGS_LABEL_MONTH_JUL);
    selectors.education.months[7].name = t9n(TS.SETTINGS_LABEL_MONTH_AUG);
    selectors.education.months[8].name = t9n(TS.SETTINGS_LABEL_MONTH_SEP);
    selectors.education.months[9].name = t9n(TS.SETTINGS_LABEL_MONTH_OCT);
    selectors.education.months[10].name = t9n(TS.SETTINGS_LABEL_MONTH_NOV);
    selectors.education.months[11].name = t9n(TS.SETTINGS_LABEL_MONTH_DEC);
  };

  $: if (!!$session) translate_texts();

  onMount(init_dialog);
</script>

<div id="dialog-language" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      style="overflow: visible;"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="language-title">

        {#if !dialog_edit_lang}
          {labels.add_language}
        {:else}{labels.edit_lang}{/if}

      </h2>

      <div
        class="mdc-dialog__content"
        id="language-content"
        style="overflow: visible">
        <div
          style="display: flex; margin-top: 20px; margin-bottom: 20px;"
          class="margin-50">
          {#if !dialog_edit_lang}
            <div style="width: 300px">
              <Selector
                id="input-language"
                label={labels.language}
                is_required={true}
                bind:input_value={form_input.language.input_value_language}
                bind:items={selectors.language.filtered_languages}
                bind:value={form_input.language.language} />
            </div>
          {:else}
            <div style="width: 300px">
              <Selector
                id="input-language-edit"
                label={labels.language}
                is_required={true}
                bind:input_value={form_input.language.input_value_language}
                bind:items={selectors.language.languages}
                bind:value={form_input.language.language_edit} />
            </div>
          {/if}

        </div>
        <div style="display: flex; height: 56px" class="margin-50">
          {#if !dialog_edit_lang}
            <div style="width: 300px">
              <Selector
                id="selector_lang_proficiency"
                label={labels.proficiency}
                is_required={true}
                bind:input_value={form_input.language.input_value_proficiency}
                bind:items={selectors.language.proficiency}
                bind:value={form_input.language.proficiency} />
            </div>
          {:else}
            <div style="width: 300px">
              <Selector
                id="selector_lang_proficiency_edit"
                label={labels.proficiency}
                is_required={true}
                bind:input_value={form_input.language.input_value_proficiency}
                bind:items={selectors.language.proficiency}
                bind:value={form_input.language.proficiency_edit} />
            </div>
          {/if}
        </div>

        <p class='required'>* {t9n(TS.REQUIRED_LABEL)}</p>
      </div>

      <footer class="mdc-dialog__actions">
        <button
          on:click={() => close_dialog_language()}
          class="btn-close mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {labels.btn_close}
        </button>

        {#if !dialog_edit_lang}
          {#if !!form_input.language.language && !!form_input.language.proficiency}
            <button
              on:click={() => add_new_language()}
              style="margin-left: 10px;"
              data-mdc-dialog-initial-focus
              id='button_add'
              class="btn-close mdc-button mdc-button--unelevated">
              <span class="mdc-button__ripple" />
              {labels.btn_add}
            </button>
          {:else}
            <button
              disabled
              style="margin-left: 10px;"
              data-mdc-dialog-initial-focus
              id='button_add'
              class="btn-close mdc-button mdc-button--unelevated">
              <span class="mdc-button__ripple" />
              {labels.btn_add}
            </button>
          {/if}
        {:else if !!form_input.language.language_edit && !!form_input.language.proficiency_edit}
          <button
            on:click={() => add_new_language()}
            style="margin-left: 10px;"
            data-mdc-dialog-initial-focus
            class="btn-close mdc-button mdc-button--unelevated">
            <span class="mdc-button__ripple" />
            {labels.btn_save}
          </button>
        {:else}
          <button
            disabled
            style="margin-left: 10px;"
            data-mdc-dialog-initial-focus
            class="btn-close mdc-button mdc-button--unelevated">
            <span class="mdc-button__ripple" />
            {labels.btn_save}
          </button>
        {/if}

      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
    .required{
        font-size: 10pt;
        margin-bottom: 20px;
        color: #323232;
        margin-left: 50px;
    }
  .mdc-dialog__surface {
    width: 450px;
  }

  .mdc-layout-grid {
    padding: 0;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .margin-50 {
      margin-left: 50px;
    }

    .padding-50 {
      padding-left: 50px;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .mdc-dialog__surface {
      height: 100%;
      max-height: 350px;
    }

    .margin-50 {
      margin-left: 50px;
    }

    .padding-50 {
      padding-left: 50px;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .margin-50 {
      margin-left: 1px;
    }

    .padding-50 {
      padding-left: 1px;
    }

    .mdc-dialog__surface {
      height: 80%;
      max-height: 350px;
    }
  }
</style>
